export default __webpack_public_path__ + "static/media/instagram.8fe010f3.svg";